<template>
    <q-page class="flex flex-center" style="background-color: #F4F4F4;">
        <router-view></router-view>
    </q-page>
  </template>
  
  <style>
  </style>
  
  <script>
  export default {
    name: 'InBoundPage'
  }
  </script>
  